const actions = {
    UPDATE_LAST_ACTION_TIMESTAMP: 'custom/UPDATE_LAST_ACTION_TIMESTAMP',
    CHECK_LAST_ACTIVITY_TIME: 'custom/CHECK_LAST_ACTIVITY_TIME',
    updateActivityTime: () => ({
        type: actions.UPDATE_LAST_ACTION_TIMESTAMP
    })
};

export default actions;